import React from 'react'
import { withRouter } from 'react-router-dom'
import { AuthContext } from '../main/authProvider'
import HandleErrorService from '../app/service/handleErrorService'
import ConstantsUtil from '../context/constantsUtil'
import GrupoDeEmpresasService from '../app/service/central/grupoDeEmpresasService'
import LoginService from '../app/service/loginService'
import LoginEmpresaDialog from '../components/loginEmpresaDialog'
import AuthService from '../app/service/authService'
import ConfiguracaoEmpresaService from '../app/service/configuracaoEmpresaService'
import GeneralServices from '../app/service/generalServices'
import logo from '../images/logo.png'
import logoWhite from '../images/logo-white.png'
import './login.css'

const entrarLabel = "Entrar"
class Login extends React.Component{
    
    constructor(){
        super();
        this.loginService = new LoginService();
        this.grupoDeEmpresasService = new GrupoDeEmpresasService()
        this.configuracaoEmpresaService = new ConfiguracaoEmpresaService()
        this.generalServices = new GeneralServices()
    }

    state = {
        email: '',
        inputEmailErrorClass: null,
        errorEmailMessage: null,

        password: '',
        inputPasswordErrorClass: null,
        errorPasswordMessage: null,

        preLoginGrupoResponse: null,
        visibleLoginEmpresaDialog: false,

        loginButtonMessage: entrarLabel,
        disableLoginButton: false,

        showPassword: false,
    }

    componentDidMount(){
        let { redirectPath, expired } = this.props.match.params;
        if(!redirectPath){
            if(AuthService.isAuth()){
                window.location = ConstantsUtil.homePathname
            }
        }
        else if(redirectPath === 'true'){
            redirectPath = ''
        }

        if(expired){
            window.location = `/login/${redirectPath}`
            this.context.endSession()
        }
    }

    handleChange = async (event) => {
        const value = event.target.value
        const name = event.target.name
        await this.setState({ [name]: value })
    }


    hanldeInputPasswordChange = (event) => {
        this.setState({password: event.target.value})
        this.setState({inputPasswordErrorClass: ''})
    }    

    resetView = () => {
        this.setState({inputEmailErrorClass: null})
        this.setState({errorEmailMessage: null})

        this.setState({inputPasswordErrorClass: null})
        this.setState({errorPasswordMessage: null})

    }

    checkData = () => {
        
        var check = true

        if (! ConstantsUtil.emailRegex.test(this.state.email) ){
            this.setState({inputEmailErrorClass: ConstantsUtil.bootstrapInputErrorClass})
            this.setState({errorEmailMessage: 'Informe um email válido'})
            check = false
        }

        if(!this.state.password){
            this.setState({inputPasswordErrorClass: ConstantsUtil.bootstrapInputErrorClass})
            this.setState({errorPasswordMessage: 'Informe a senha'})
            check = false
        }

        return check
    }

    preLogin = () => {

        if(!this.checkData()){
            return;
        }

        this.setState({loginButtonMessage: 'Entrando...'})
        this.setState({disableLoginButton: true})
        this.loginService.preLogin({
            email: this.state.email,
            password: this.state.password
        }).then(async response => {
            await this.setState({preLoginGrupoResponse: response.data})
            this.setState({visibleLoginEmpresaDialog: true})
        })
        .catch(error => {
            this.setState({loginButtonMessage: entrarLabel})
            HandleErrorService.handleError(error)
        })
        .finally(() => {
            this.setState({disableLoginButton: false})
        })
    }

    login = (tenantName) => {

        this.resetView()
        
        if(!this.checkData()){
            return;
        }
        
        this.loginService.auth(
        {
            email: this.state.email,
            password: this.state.password,
            tenantName: tenantName
        }).then(async response => {
            let user = response.data
            this.generalServices.completaLogin(user, this.context);
        }).catch(error => {
            if(error.response){
            var data = error.response.data
            if(data.toLowerCase().includes("email")){
            this.setState({errorEmailMessage: error.response.data})
            this.setState({inputEmailErrorClass: "is-invalid"})
            } else if(data.toLowerCase().includes("senha")){
                this.setState({errorPasswordMessage: error.response.data})
                this.setState({inputPasswordErrorClass: "is-invalid"})
            }
            }
            HandleErrorService.handleError(error)
            this.enableLoginButton()
        })
    }

    enableLoginButton = () => {
        this.setState({loginButtonMessage: entrarLabel})
        this.setState({disableLoginButton: false})
    }

    handleKeypress = e => {
        //it triggers by pressing the enter key
      if (e.key === "Enter") {
        this.preLogin();
      }
    }

    hideDialog = (shouldEnableLoginButton) => {
        this.setState({visibleLoginEmpresaDialog: false})
        if(shouldEnableLoginButton){
            this.enableLoginButton()
        }
    }

    render(){
        const {
            email, inputEmailErrorClass, errorEmailMessage,
            password, inputPasswordErrorClass, errorPasswordMessage,
            loginButtonMessage, disableLoginButton,
            visibleLoginEmpresaDialog, preLoginGrupoResponse,
            showPassword,
        } = this.state

        return (
            <div className="login-page-container">

                {/* ── Painel esquerdo: branding ── */}
                <div className="login-panel-left">
                    <div className="login-brand-logo-wrap">
                        <img src={logoWhite} alt="Logo" className="login-brand-logo" />
                    </div>
                    <p className="login-brand-title">
                        <span className="login-brand-name">Bepp</span>
                        <span className="login-brand-separator">·</span>
                        Gestão Financeira
                    </p>
                    <p className="login-brand-subtitle">
                        Gerencie as finanças de sua empresa com<br />simplicidade e segurança
                    </p>
                    <a href="/apresentacao" className="login-apresentacao-btn">
                        Saiba mais
                        <i className="pi pi-arrow-right" />
                    </a>
                </div>

                {/* ── Painel direito: formulário ── */}
                <div className="login-panel-right">
                    <div className="login-form-card">

                        <img src={logo} alt="Logo" className="login-card-logo" />
                        <p className="login-form-heading">Bem-vindo</p>
                        <p className="login-form-subheading">Entre na sua conta para continuar</p>

                        {/* Email */}
                        <div style={{marginBottom: '16px'}}>
                            <label>Email</label>
                            <input
                                type="email"
                                value={email}
                                onChange={e => this.setState({email: e.target.value})}
                                onKeyPress={this.handleKeypress}
                                placeholder="seu@email.com"
                                className={inputEmailErrorClass ? 'input-error' : ''}
                            />
                            {errorEmailMessage && (
                                <span className="login-error-msg">{errorEmailMessage}</span>
                            )}
                        </div>

                        {/* Senha */}
                        <div style={{marginBottom: '24px'}}>
                            <label>Senha</label>
                            <div className="login-password-wrapper">
                                <input
                                    type={showPassword ? 'text' : 'password'}
                                    value={password}
                                    onChange={this.hanldeInputPasswordChange}
                                    onKeyPress={this.handleKeypress}
                                    placeholder="Digite sua senha"
                                    autoComplete="current-password"
                                    className={inputPasswordErrorClass ? 'input-error' : ''}
                                />
                                <button
                                    type="button"
                                    className="login-password-toggle"
                                    onClick={() => this.setState({showPassword: !showPassword})}
                                    tabIndex={-1}
                                >
                                    <i className={showPassword ? 'pi pi-eye-slash' : 'pi pi-eye'} />
                                </button>
                            </div>
                            {errorPasswordMessage && (
                                <span className="login-error-msg">{errorPasswordMessage}</span>
                            )}
                        </div>

                        {/* Entrar */}
                        <button
                            className="login-btn-primary"
                            onClick={this.preLogin}
                            disabled={disableLoginButton}
                        >
                            <i className="pi pi-sign-in" />
                            {loginButtonMessage}
                        </button>

                        {/* Esqueceu senha */}
                        <div style={{marginTop: '14px', textAlign: 'center'}}>
                            <button
                                type="button"
                                className="login-btn-link"
                                onClick={() => this.props.history.push('/recoverPassword')}
                            >
                                Esqueceu a senha?
                            </button>
                        </div>

                    </div>
                </div>

                <LoginEmpresaDialog
                    visible={visibleLoginEmpresaDialog}
                    grupos={preLoginGrupoResponse}
                    hideDialog={this.hideDialog}
                    login={this.login}
                />
            </div>
        )
    }
    
}

Login.contextType = AuthContext

export default withRouter(Login)